export default [
  {
    path: '/question',
    name: 'question',
    meta: {
      title: '调查问卷'
    },
    component: () => import('@v/question/index.vue')
  },
  {
    path: '/ecode/activity',
    name: 'ecode_activity',
    meta: {
      title: '发码活动'
    },
    component: () => import('@v/ecode/activity.vue')
  },
  {
    path: '/coupon/activity',
    name: 'coupon_activity',
    meta: {
      title: '优惠券活动'
    },
    component: () => import('@v/coupon/activity.vue')
  },
  {
    path: '/wework/activity',
    name: 'wework_activity',
    meta: {
      title: '企业微信活动'
    },
    component: () => import('@v/wework/activity.vue')
  },
  {
    path: '/wework/choose_city',
    name: 'wework_choose_city',
    meta: {
      title: '选择城市'
    },
    component: () => import('@v/wework/choose-city.vue')
  },
  {
    path: '/h5',
    name: 'h5',
    meta: {
      title: '保护濒危动物原创设计大赛'
    },
    component: () => import('@v/h5/index.vue')
  },
  {
    path: '/h5/video',
    name: 'video',
    meta: {
      title: ''
    },
    component: () => import('@v/h5/video.vue')
  }
]